import { render, staticRenderFns } from "./ODpay_order_detail.vue?vue&type=template&id=e6b7e952&scoped=true"
import script from "./ODpay_order_detail.vue?vue&type=script&lang=js"
export * from "./ODpay_order_detail.vue?vue&type=script&lang=js"
import style0 from "./ODpay_order_detail.vue?vue&type=style&index=0&id=e6b7e952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b7e952",
  null
  
)

export default component.exports